import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from './api/axiosInstance';
import base_url from './api/Config';
import TopBar from './component/TopBar';

const LoanInfo = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  const location = useLocation();
  const navigate = useNavigate();
  const id = new URLSearchParams(location.search).get('id');

  useEffect(() => {
    if (!id) return;
    api.get(`${base_url}/api/userProduct/application`, { params: { id } })
      .then(res => setData(res.data))
      .catch(() => setError('Error fetching loan information'));
  }, [id]);

  const total = data
    ? (parseFloat(data.processFee || 0) + parseFloat(data.verificationFee || 0) + parseFloat(data.assuranceFee || 0))
    : 0;

  const rows = data ? [
    { label: 'Loan Amount', value: `₹${data.loanAmount} /-` },
    { label: 'Processing Fee', value: `₹${data.processFee} /-` },
    { label: 'Verification Charges', value: `₹${data.verificationFee} /-` },
    { label: 'Assurance Charges', value: `₹${data.assuranceFee} /-` },
    { label: 'Total File Charges', value: `₹${total.toFixed(2)} /-` },
    { label: 'Hospicash', value: `₹${data.hospiCash} /-` },
    { label: 'Rate of Interest', value: `${data.intRate}%` },
    { label: 'Interest Amount', value: `₹${parseFloat(data.interestAmount || 0).toFixed(2)} /-` },
    { label: 'Loan Type', value: data.loanType },
    { label: 'Disbursed Amount', value: `₹${data.disbursementAmount}` },
    { label: 'APR', value: `${data.apr}%` },
    { label: 'Number of Repayments', value: data.noOfInstalment },
    { label: 'Repayment Amount', value: `₹${data.emiAmount}` },
    { label: 'Collection Fee', value: `₹${data.collectionFee}` },
    { label: 'Platform Fee', value: `₹${data.platformFee}` },
    { label: 'Convenience Fee', value: `₹${data.convenienceFee}` },
    { label: 'Total Paid Amount', value: `₹${data.tob}` },
  ] : [];

  return (
    <div className="app-page">
      <TopBar title="Loan Information" backPath={`/CustomerEmiPage?id=${id}`} />

      <div className="app-content">
        {error ? (
          <div className="app-card" style={{ color: '#e53935', textAlign: 'center' }}>{error}</div>
        ) : !data ? (
          <div className="app-card" style={{ textAlign: 'center', color: '#888' }}>Loading...</div>
        ) : (
          <div className="app-card">
            <p className="section-title">Loan Breakdown</p>
            {rows.map((row, i) => row.value && row.value !== '₹undefined' && row.value !== 'undefined%' ? (
              <div key={i} className="info-row">
                <span>{row.label}</span>
                <strong>{row.value}</strong>
              </div>
            ) : null)}
          </div>
        )}

        <button className="btn-primary-app" onClick={() => navigate(`/CustomerEmiPage?id=${id}`)}>
          Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default LoanInfo;
